import ReactGA from 'react-ga4';
import { mxConfig } from '../config';

// Read tracking ID from env config
if (mxConfig.gaMeasurementId?.length) {
  ReactGA.initialize(mxConfig.gaMeasurementId);
}
